import React, { useEffect, useState } from "react";
import Footer from '../components/footer';
import { useMoralis } from 'react-moralis';
import UserIdenticon from '../commons/UserIdenticon';
import { getSliceLongTxt } from "../../helpers/formatters";
import CreatorOnSaleNFTList from "../components/creator-profile/CreatorOnSaleNFTList";
import { Link } from "@reach/router";
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { toast } from 'react-toastify'

const CreatorProfile = ({ walletAddress }) => {

  const { Moralis, isInitialized } = useMoralis()
  const [isLoadingProfile, setIsLoadingProfile] = useState(false)
  const [profileData, setProfileData] = useState({})
  const [value, setValue] = useState('')
  const [copied, setCopied] = useState(false)

  const getUserImage = (moralisAttributes, imageSize = 50) => {

    if (moralisAttributes) {
      if ("profileImageCID" in moralisAttributes && moralisAttributes.profileImageCID != null) {
        const profileImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${moralisAttributes.profileImageCID}`
        return <img className="profile-image" src={profileImageUrl} alt="" />
      } else {
        return <UserIdenticon size={imageSize} walletAddress={moralisAttributes.walletAddress} />
      }
    } else {
      return <UserIdenticon size={imageSize} walletAddress={walletAddress} />
    }

  }

  const getUsername = (moralisAttributes) => {

    if (moralisAttributes) {
      if ("username" in moralisAttributes && moralisAttributes.username !== "") {
        return moralisAttributes.username
      } else {
        return '@Unnamed'
      }
    } else {
      return '@Unnamed'
    }

  }




  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    try {
      if (isInitialized) {
        setIsLoadingProfile(true)
        const params = { walletAddress };
        const profileDataResponse = await Moralis.Cloud.run("getCreatorDetailsByAddress", params);
        setProfileData(profileDataResponse)
        setIsLoadingProfile(false)
      }
    } catch (error) {
      setIsLoadingProfile(false)
      setProfileData({})
      console.error("MORALIS : error while fetching profile data ", error)

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized])


  const [openMenu1, setOpenMenu1] = React.useState(false);
  const [openYouNFTs, setOpenYouNFTs] = useState(true)
  const handleYourNFTBtnClick = () => {

    setOpenYouNFTs(!openYouNFTs);
    setOpenMenu1(false);
    document.getElementById("Mainbtn").classList.add("active");
    document.getElementById("Mainbtn1").classList.remove("active");
  }

  const handleBtnClick1 = () => {
    setOpenMenu1(!openMenu1);
    setOpenYouNFTs(false);
    document.getElementById("Mainbtn1").classList.add("active");
    document.getElementById("Mainbtn").classList.remove("active");
  };

  const onCopy = () => {
    setCopied(true)
    setValue(walletAddress)
    if (copied) {
      toast.dark('Wallet address copied!', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  return (

    <div>
      <div>
        <section className='container no-bottom'>
          <div className='row'>
            <div className='spacer-double'></div>

            {
              isLoadingProfile ? (

                <div className='col-lg-12'>
                  <div className='loading-container mb-4'>
                    <div className="spinner-grow" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>

              ) : (
                <div className="col-md-12">
                  <div className="d_profile de-flex">
                    <div className="de-flex-col">
                      <div className="profile_avatar">
                        {/* <img src="/img/author_single/author_thumbnail.jpg" alt="" /> */}
                        {getUserImage(profileData.attributes, 150)}
                        <div className="profile_name">
                          <h4>
                            {/* {getUsername(profileData?.attributes)} */}
                            <span className="profile_username">{getUsername(profileData ? profileData.attributes : null)}</span>
                            <span id="wallet" className="profile_wallet">{walletAddress}</span>
                            <CopyToClipboard onCopy={onCopy} text={walletAddress}>
                              <button id="btn_copy" title="Copy Text">Copy</button>
                            </CopyToClipboard>
                            <p className="profile_bio">{getSliceLongTxt((profileData && profileData.attributes) ? profileData.attributes.bio : '', 150)}</p>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }

          </div>
        </section><section className='container no-top'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className="items_filter">
                <ul className="de_nav text-left">
                  <li id='Mainbtn' className="active"><span onClick={handleYourNFTBtnClick}>On Sale NFT(s)</span></li>
                  <li id='Mainbtn1' className=""><span onClick={handleBtnClick1}>Created NFT(s)</span></li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            {openYouNFTs && (
              <div id='zero1' className='onStep fadeIn'>
                <CreatorOnSaleNFTList walletAddress={walletAddress} />
              </div>
            )}
            {openMenu1 && (
              <div id='zero2' className='onStep fadeIn'>
                <CreatorOnSaleNFTList walletAddress={walletAddress} />
              </div>
            )}
          </div>
        </section>

      </div >
      <Footer />
    </div>
  );
}
export default CreatorProfile;